import { Mail } from "lucide-react";
import { SlSocialLinkedin, SlSocialGithub } from "react-icons/sl";
import "./Footer.css";

// Footer with Social Links
export default function Footer() {
  const socialLinks = [
    {
      icon: SlSocialLinkedin,
      href: "https://www.linkedin.com/in/cleo-buenaventura/",
      label: "LinkedIn",
    },
    {
      icon: SlSocialGithub,
      href: "https://github.com/cleobnvntra",
      label: "GitHub",
    },
    { icon: Mail, href: "mailto:cj.buenaventura09@gmail.com", label: "Email" },
  ];

  return (
    <footer
      className="py-12 bg-[#010A13] border-t border-[#3C3C41]"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col items-center">
          {/* Social Links */}
          <div className="flex gap-4 mb-8">
            {socialLinks.map((social, index) => {
              const Icon = social.icon;
              return (
                <a
                  key={index}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  aria-label={social.label}
                  data-testid={`social-${social.label.toLowerCase()}`}
                >
                  <Icon size={20} />
                </a>
              );
            })}
          </div>

          <p className="text-[#A09B8C] text-sm">
            Built by <span className="text-[#C89B3C]">Cleo Buenaventura</span>
          </p>
          <p className="text-[#3C3C41] text-xs mt-1">
            Theme inspired by League of Legends.
          </p>
        </div>
      </div>
    </footer>
  );
}
